export default __webpack_public_path__ + "static/media/aboutImage.45ad90a1.jpeg";